import PeLink from '@pe-libs/react-components/build/components/PeLink';
import useIntlMessage from '@pe-libs/react-components/build/lib/intl/hooks/useIntlMessage';
import React from 'react';
import useRedirect from '#hooks/useRedirect';
import useStyles from './styles';

type ErrorProps = {
  label?: { id: string };
  text: { id: string };
};

const Error: React.FC<ErrorProps> = ({ label, text }) => {
  const formatMessage = useIntlMessage();
  const styles = useStyles();
  const { urlToLivePage } = useRedirect();

  return (
    <div>
      {formatMessage(
        text,
        label && {
          link: (
            <PeLink href={urlToLivePage('login')} className={styles.link}>
              {formatMessage(label)}
            </PeLink>
          ),
        },
      )}
    </div>
  );
};

export default Error;
